/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kullanim_S18_I3_TextInputs */

const tr_kullanim_s18_i3_text = /** @type {(inputs: Kullanim_S18_I3_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Şirket bu Sözleşme'yi güncelleme hakkını saklı tutar. Esaslı değişiklikler en az 30 gün önceden e-posta ve Platform üzerinden bildirilir.`)
};

const en_kullanim_s18_i3_text = /** @type {(inputs: Kullanim_S18_I3_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Company reserves the right to update this Agreement. Material changes are notified at least 30 days in advance by email and through the Platform.`)
};

const de_kullanim_s18_i3_text = /** @type {(inputs: Kullanim_S18_I3_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Unternehmen behält sich das Recht vor, diesen Vertrag zu aktualisieren. Wesentliche Änderungen werden mindestens 30 Tage im Voraus per E-Mail und über die Plattform mitgeteilt.`)
};

const ru_kullanim_s18_i3_text = /** @type {(inputs: Kullanim_S18_I3_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Компания оставляет за собой право обновлять настоящий Договор. О существенных изменениях сообщается не менее чем за 30 дней по электронной почте и через Платформу.`)
};

/**
* | output |
* | --- |
* | "The Company reserves the right to update this Agreement. Material changes are notified at least 30 days in advance by email and through the Platform." |
*
* @param {Kullanim_S18_I3_TextInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kullanim_s18_i3_text = /** @type {((inputs?: Kullanim_S18_I3_TextInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kullanim_S18_I3_TextInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kullanim_s18_i3_text(inputs)
	if (locale === "de") return de_kullanim_s18_i3_text(inputs)
	if (locale === "ru") return ru_kullanim_s18_i3_text(inputs)
	return tr_kullanim_s18_i3_text(inputs)
});